import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate, Link } from 'react-router-dom';

export default function Signup() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [displayName, setDisplayName] = useState('');
    const [address, setAddress] = useState('');
    const [notes, setNotes] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);

    const { signup } = useAuth();
    const navigate = useNavigate();

    async function handleSubmit(e) {
        e.preventDefault();

        if (password.length < 6) {
            return setError('הסיסמה חייבת להיות לפחות 6 תווים');
        }

        try {
            setError('');
            setLoading(true);
            await signup(email, password, displayName, address, notes);
            navigate('/dashboard');
        } catch (err) {
            setError('שגיאה ביצירת חשבון: ' + err.message);
        }
        setLoading(false);
    }

    return (
        <div style={styles.container}>
            <div style={styles.card}>
                <h2 style={styles.title}>♠️♥️ הרשמה - פוקר ♦️♣️</h2>
                {error && <div style={styles.error}>{error}</div>}

                <form onSubmit={handleSubmit}>
                    <div style={styles.formGroup}>
                        <label style={styles.label}>שם מלא *</label>
                        <input
                            type="text"
                            value={displayName}
                            onChange={(e) => setDisplayName(e.target.value)}
                            required
                            style={styles.input}
                            dir="rtl"
                            onFocus={(e) => e.target.style.borderColor = '#ffd966'}
                            onBlur={(e) => e.target.style.borderColor = '#c0c0c0'}
                        />
                    </div>

                    <div style={styles.formGroup}>
                        <label style={styles.label}>אימייל *</label>
                        <input
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                            style={styles.input}
                            onFocus={(e) => e.target.style.borderColor = '#ffd966'}
                            onBlur={(e) => e.target.style.borderColor = '#c0c0c0'}
                        />
                    </div>

                    <div style={styles.formGroup}>
                        <label style={styles.label}>סיסמה *</label>
                        <div style={styles.passwordWrapper}>
                            <input
                                type={showPassword ? "text" : "password"}
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                                style={styles.input}
                                onFocus={(e) => e.target.style.borderColor = '#ffd966'}
                                onBlur={(e) => e.target.style.borderColor = '#c0c0c0'}
                            />
                            <button
                                type="button"
                                onClick={() => setShowPassword(!showPassword)}
                                style={styles.toggleButton}
                                aria-label={showPassword ? "הסתר סיסמה" : "הצג סיסמה"}
                                onMouseEnter={(e) => e.target.style.transform = 'scale(1.1)'}
                                onMouseLeave={(e) => e.target.style.transform = 'scale(1)'}
                            >
                                {showPassword ? "🙈" : "👁️"}
                            </button>
                        </div>
                    </div>

                    <div style={styles.formGroup}>
                        <label style={styles.label}>כתובת (אופציונלי)</label>
                        <input
                            type="text"
                            value={address}
                            onChange={(e) => setAddress(e.target.value)}
                            placeholder="רחוב, עיר"
                            style={styles.input}
                            dir="rtl"
                            onFocus={(e) => e.target.style.borderColor = '#ffd966'}
                            onBlur={(e) => e.target.style.borderColor = '#c0c0c0'}
                        />
                        <small style={styles.helpText}>כתובת לאירוח משחקים</small>
                    </div>

                    <div style={styles.formGroup}>
                        <label style={styles.label}>הערות (אופציונלי)</label>
                        <textarea
                            value={notes}
                            onChange={(e) => setNotes(e.target.value)}
                            placeholder="קוד כניסה, קומה, מספר דירה וכו׳"
                            style={{...styles.input, minHeight: '60px', resize: 'vertical'}}
                            dir="rtl"
                            onFocus={(e) => e.target.style.borderColor = '#ffd966'}
                            onBlur={(e) => e.target.style.borderColor = '#c0c0c0'}
                        />
                    </div>

                    <button
                        disabled={loading}
                        type="submit"
                        style={{
                            ...styles.button,
                            opacity: loading ? 0.7 : 1,
                            cursor: loading ? 'not-allowed' : 'pointer',
                        }}
                        onMouseEnter={(e) => {
                            if (!loading) {
                                e.target.style.transform = 'translateY(-3px) scale(1.02)';
                                e.target.style.boxShadow = '0 8px 25px rgba(0, 112, 8, 0.6), inset 0 0 0 2px #ffffff, inset 0 0 0 4px #007008';
                            }
                        }}
                        onMouseLeave={(e) => {
                            if (!loading) {
                                e.target.style.transform = 'translateY(0) scale(1)';
                                e.target.style.boxShadow = '0 6px 20px rgba(0, 112, 8, 0.4), inset 0 0 0 2px #ffffff, inset 0 0 0 4px #007008';
                            }
                        }}
                    >
                        {loading ? '🎰 מעבד...' : '🎰 הרשמה'}
                    </button>
                </form>

                <div style={styles.footer}>
                    כבר יש לך חשבון? <Link to="/login">התחבר</Link>
                </div>
            </div>
        </div>
    );
}

const styles = {
    container: {
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #1a1a1a 0%, #000000 50%, #1a1a1a 100%)',
        direction: 'rtl',
        padding: '15px',
    },
    card: {
        backgroundColor: '#ffffff',
        padding: '35px 30px',
        borderRadius: '15px',
        boxShadow: '0 12px 40px rgba(0, 0, 0, 0.8), inset 0 0 0 8px #ffffff, inset 0 0 0 12px #ffd966',
        width: '100%',
        maxWidth: '450px',
        border: '3px solid #000000',
        position: 'relative',
        overflow: 'hidden',
        background: 'linear-gradient(145deg, #ffffff 0%, #f5f5f5 100%)',
    },
    title: {
        textAlign: 'center',
        marginBottom: '25px',
        color: '#000000',
        fontSize: 'clamp(20px, 5vw, 26px)',
        fontWeight: 'bold',
        textShadow: '2px 2px 4px rgba(0, 0, 0, 0.1)',
        letterSpacing: '0.5px',
        lineHeight: '1.3',
    },
    error: {
        backgroundColor: '#ffe5e5',
        color: '#cc0000',
        padding: '12px',
        borderRadius: '8px',
        marginBottom: '20px',
        textAlign: 'center',
        border: '2px solid #cc0000',
        fontSize: '14px',
    },
    formGroup: {
        marginBottom: '18px',
    },
    label: {
        display: 'block',
        marginBottom: '8px',
        fontWeight: '600',
        color: '#000000',
        fontSize: '15px',
    },
    input: {
        width: '100%',
        padding: '14px 16px',
        border: '2px solid #c0c0c0',
        borderRadius: '8px',
        fontSize: '16px',
        boxSizing: 'border-box',
        backgroundColor: '#ffffff',
        color: '#000000',
        transition: 'all 0.3s ease',
        outline: 'none',
    },
    passwordWrapper: {
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
    },
    toggleButton: {
        position: 'absolute',
        left: '12px',
        background: 'none',
        border: 'none',
        cursor: 'pointer',
        fontSize: '22px',
        padding: '8px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        transition: 'transform 0.2s ease',
        zIndex: 10,
    },
    helpText: {
        display: 'block',
        marginTop: '6px',
        fontSize: '12px',
        color: '#666666',
    },
    button: {
        width: '100%',
        padding: '18px',
        background: 'radial-gradient(circle at 30% 30%, #007008, #005006 40%, #007008 60%, #005006)',
        color: '#ffffff',
        border: '4px solid #000000',
        borderRadius: '50px',
        fontSize: '17px',
        fontWeight: 'bold',
        cursor: 'pointer',
        transition: 'all 0.3s ease',
        boxShadow: '0 6px 20px rgba(0, 112, 8, 0.4), inset 0 0 0 2px #ffffff, inset 0 0 0 4px #007008',
        textTransform: 'uppercase',
        letterSpacing: '1.5px',
        marginTop: '10px',
    },
    footer: {
        marginTop: '25px',
        textAlign: 'center',
        color: '#333333',
        fontSize: '15px',
    },
};
